/**
 * 订单列表接口，包括订单详情、订单编辑、提交签收单等
 * @author yangyu
 */
export default {
  BASE_URL: '',
  api: [
    {
      name: 'transform',
      desc: '生成明细订单',
      method: 'POST',
      path: '/tmb/order/createDetail'
    },
    {
      name: 'detail',
      desc: '获取订单详情',
      method: 'GET',
      path: '/tmb/order/editDetail'
    },
    // 获取订单详情
    {
      name: 'detailV5',
      desc: '获取订单详情V5',
      method: 'GET',
      path: '/tm/order/getOrderById'
    },
    // 送货单
    {
      name: 'receiveDetail',
      desc: '获取签收单详情',
      method: 'GET',
      path: '/tm/order/receipt/tmb/signDel'
    },
    {
      name: 'receiveLog',
      desc: '签收单日志',
      method: 'GET',
      path: '/tm/order/receipt/supplier/log'
    },
    {
      name: 'saveReceive',
      desc: '提交签收单',
      method: 'POST',
      path: '/tm/order/receipt/tmb/sup/subSign'
    },
    {
      name: 'status',
      desc: '获取订单状态（页签）',
      method: 'GET',
      path: '/tmb/order/billStatus'
    },
    {
      name: 'getStatusOrderNum',
      desc: '获取状态订单数目',
      method: 'GET',
      path: '/tm/order/getStatusOrderNum'
    },
    {
      name: 'statusSelect',
      desc: '获取订单状态下拉框数据',
      method: 'GET',
      path: '/tmb/order/selectStatus'
    },
    {
      name: 'list',
      desc: '获取订单列表',
      method: 'GET',
      path: '/tmb/order/showList'
    },
    {
      name: 'getStoreBySupplierId',
      desc: '获取供应商仓库',
      method: 'GET',
      path: '/tmb/order/getStorageByOrgId'
    },
    {
      name: 'save',
      desc: '保存订单',
      method: 'POST',
      path: '/tmb/order/saveOrder'
    },
    {
      name: 'submit',
      desc: '提交订单',
      method: 'POST',
      path: '/tmb/order/subOrder'
    },
    {
      name: 'cenPurSubmit',
      desc: '集采提交订单',
      method: 'POST',
      path: '/tmb/order/cenPurSubmit'
    },
    {
      name: 'changeStatus',
      desc: '改变订单状态',
      method: 'POST',
      path: '/tm/order/updateOrderStatus'
    },
    {
      name: 'checkOrderInfoV5',
      desc: '校验订单关联信息（订单由发货中到已完成阶段）',
      method: 'GET',
      path: '/tm/order/checkOrderInfo'
    },
    {
      name: 'cancel',
      desc: '取消订单',
      method: 'POST',
      path: '/tmb/order/autoCancelOrder'
    },
    {
      name: 'exportExcelFromOrderSearch',
      desc: '订单查询导出excel',
      method: 'GET',
      path: '/tmb/order/export'
    },
    {
      name: 'getSobOrgByType',
      desc: '服务供应商类型查询供应商',
      method: 'GET',
      path: '/tmb/order/getSobOrgByType'
    },
    {
      name: 'import',
      desc: '订单导入',
      method: 'POST',
      path: '/tmb/order/import'
    },
    {
      name: 'template',
      desc: '订单模板下载',
      method: 'GET',
      path: '/tmb/order/template'
    },
    {
      name: 'addProd',
      desc: '添加商品',
      method: 'POST',
      path: '/tmb/order/addProds'
    },
    {
      name: 'subAndCloseOrder',
      desc: '提交审批并关闭父订单',
      method: 'POST',
      path: '/tmb/order/subAndCloseOrder'
    },
    {
      name: 'getOrderFlow',
      desc: '获取订单流程及操作日志',
      method: 'GET',
      path: '/tm/order/getOrderFlow'
    },
    {
      name: 'handlerOrderV5',
      desc: '提交订单',
      method: 'POST',
      path: '/tm/order/handlerOrder'
    },
    {
      name: 'getVerifierUserListV5',
      desc: '获取跟单业务员下拉V5',
      method: 'GET',
      path: '/mm/store/getVerifierUserList'
    },
    {
      name: 'listV5',
      desc: '获取订单列表',
      method: 'GET',
      path: '/tm/order/orderList'
    },
    {
      name: 'getBizUnitListV5',
      desc: '获取供货单位下拉V5',
      method: 'GET',
      path: '/mm/store/getBizUnitList'
    },
    {
      name: 'getBussTypeListV5',
      desc: '获取业务类型下拉V5',
      method: 'GET',
      path: '/tm/order/getBussTypeList'
    },
    {
      name: 'getDepListV5',
      desc: '获取业务部门下拉V5',
      method: 'GET',
      path: '/sys/department/getDepList'
    },
    {
      name: 'orderQueryExportV5',
      desc: '销售查询导出V5',
      method: 'GET',
      path: '/tm/order/export'
    },
    {
      name: 'orderCancellationV5',
      desc: '一键退整单',
      method: 'POST',
      path: '/tm/order/receipt/thd/save/shortCut'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/order/list.js